/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Link, Typography } from "@material-ui/core";

/* Data Imports */

import AppConfig from "../../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  flex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    width: "100%",
  },
  link: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    margin: "0rem 1rem 0rem 1rem",
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 0rem 0rem",
    },
    color: "#666666",
    "&:hover": {
      color: "#666666",
      textDecoration: "none",
    },
    padding: "1rem 0rem 0rem 0rem",
  },
  iconLink: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    fontWeight: 800,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#666666",
    "& > svg": {
      fill: "#000000",
    },
  },
}));

const SectionThree = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.flex}>
        {/* Whatsapp */}
        <Link
          href="https://wa.me/+919513689999"
          rel="noopener"
          aria-label="whatsapp"
          title="whatsapp"
          className={classes.link}
        >
          <Typography
            variant="body1"
            component="span"
            className={classes.iconLink}
          >
            <img
              alt={AppConfig.imageAltText}
              loading="lazy"
              referrerPolicy="no-referrer"
              height={28}
              width={28}
              style={{ marginRight: "0.5rem" }}
              src="/images/icons/social/whatsapp.svg"
            />
            +91 9513689999
          </Typography>
        </Link>

        {/* Email */}
        <Link
          href="mailto:mail@heavie.co"
          rel="noopener"
          aria-label="email"
          title="email"
          className={classes.link}
        >
          <Typography
            variant="body1"
            component="span"
            className={classes.iconLink}
          >
            <img
              alt={AppConfig.imageAltText}
              loading="lazy"
              referrerPolicy="no-referrer"
              height={28}
              width={28}
              style={{ marginRight: "0.5rem" }}
              src="/images/icons/social/email.svg"
            />
            mail@heavie.co
          </Typography>
        </Link>
      </div>
    </React.Fragment>
  );
};

export default SectionThree;
